import { useState } from 'react';
import { TextMorph } from '@/components/core/text-morph';

/**
 * @param {{
 *   id: string;
 *   className?: string;
 *   bodyId: string;
 *   initialExpanded?: boolean;
 * }} props
 */
export function PanelToggleButton({ id, className, bodyId, initialExpanded = true }) {
  const [expanded, setExpanded] = useState(initialExpanded);

  const handleClick = () => {
    const body = document.getElementById(bodyId);
    const hidden = body?.classList.toggle('is-collapsed');
    setExpanded(!hidden);
  };

  return (
    <button
      type="button"
      id={id}
      className={className}
      aria-expanded={expanded}
      aria-controls={bodyId}
      onClick={handleClick}
    >
      <TextMorph as="span" className="settings-toggle__label">
        {expanded ? 'Hide' : 'Show'}
      </TextMorph>
    </button>
  );
}
